/**
 *    @author: Andrew Sheen
 *    @since:  2021-01-28
 *
 */

import { ViewportScroller } from '@angular/common';
import { Router } from '@angular/router'; 
import { TimerService } from 'src/refresh/service/timer-service';
import { Code, Confirm, Country } from 'src/refresh/service/constant';
import { FormBaseComponent } from '../_common/component/form-base.component';
import { ItemList } from '../_common/constant/item-list';
import { InputData, Name, ParentInfo } from '../_common/data/input-data';
import { AboutTheParentsScreenValidation } from './about_the_parents_screen.validator';
import { Progress } from '../_common/constant/page-const';
var show = console.log.bind( console );

export class AboutTheParentsScreenComponent extends FormBaseComponent  {

       public parent:ParentInfo;
       public parentCount:number;
       public parentParam:Object;

       public isBirthParent:boolean;
       public isSurrogate:boolean;
       public isSingleName:boolean;
       public isCustodyOtherThanParent:boolean;

       public hasSingleName:string;

       public error_parentType:string;
       public error_maritalStatus:string;
       public error_pregnancyDuration:string;
       public error_previousBirth:string;
       public error_howManyLiveBorn:string;
       public error_howManyStillBorn:string;

       public error_lastNameAtBirth:string;
       public error_birthNameInput:string;

       public error_otherLastName:string;
       public error_prevNameInput:string;

       public error_whenParentBorn:string;

       public error_city:string;
       public error_province:string;
       public error_country:string;
       public error_otherCountry:string;

       constructor( protected router: Router ,
                    public timerService:TimerService,
                    public data:InputData ,
                    public items:ItemList,  
                    public viewportScroller: ViewportScroller,
                    public parentIndex:number) {

                    super(router,timerService);  


                    this.parentCount = this.data.eligibility.listedParentCount;
                    this.parent      = this.data.parentList[parentIndex];

                    super.setValidator(new AboutTheParentsScreenValidation(this,Progress.AboutParent));

                    this.parentParam = { parentName: this.parent.name.getFullName(), 
                                         childBirth: this.items.dateFormat(this.data.aboutChild.birthDay) };

                    InputData.currentPageIdx = parentIndex+11;
                    if ( InputData.moveNext == 0 || InputData.moveNext == InputData.currentPageIdx ) this.timerService.isForwarding = false;
       }

       /**
       private getBirthParentIdx() : number {
               for ( let i = 0; i < this.data.eligibility.listedParentCount; i++ ) {
                     if ( this.data.parents[i].isGiveBirth == Confirm.YES ) return i;
               }
               return 0;
       }
        */

       public get parentYear() {
              if ( this.parent.whenParentBorn && this.parent.whenParentBorn.length >= 10 ) {
                   return this.parent.whenParentBorn.substring(0,4);
              }
              return "";
       }

       public init() {  // ngOnInit()

              if ( super.forwardNext(InputData.currentPageIdx) ) return;

              this.isBirthParent = this.parent.isGiveBirth == 'Y';
              this.isSingleName  = this.parent.name.chk_singleName == 'Y';
              this.isSurrogate   = this.data.eligibility.isBornThroughSurrogacy==Confirm.YES;
              this.isCustodyOtherThanParent = this.data.eligibility.isCustodyOtherThanParent == Confirm.YES;

              if ( this.parentIndex == 0 && !this.isSurrogate )  {
                   if ( this.isSingleName) this.hasSingleName = 'T';
                   else                    this.hasSingleName = 'F';
              }
              else {
                  if ( this.isSingleName) this.hasSingleName = 'Y';
                  else                    this.hasSingleName = 'N';
              }
       }

       public onCountrySelected() {

              if ( this.parent.placeOfBirth.country == this.NotFound ) {
                   this.error_otherCountry = '';
                   document.getElementById('input_otherCountry').focus();
              }
              else this.parent.placeOfBirth.otherCountry = "";
       }

       public onProvinceChange() {

              if ( this.parent.placeOfBirth.province &&
                   this.parent.placeOfBirth.province != Code.NotApplicable && 
                  !this.parent.placeOfBirth.country &&
                   this.parent.placeOfBirth.country != Code.NotFound  
                  ) {
                        this.parent.placeOfBirth.country = Country.CANADA;
                        this.error_country = '';
              }
       }

       public onNextClick(): boolean {

              this.parent.placeOfBirth.birthPlace = this.getBirthPlace();
              if ( this.parent.isOtherLastNameAtBirth != Confirm.YES )
                   this.parent.lastNameAtBirth = "";

              if ( this.parent.isOtherPreviousName != Confirm.YES )
                   this.parent.previousLastName = "";

              if ( this.parent.isPreviousBirth != Confirm.YES ) {
                   this.parent.howManyLiveborn  = undefined;
                   this.parent.howManyStillborn = undefined;
              }
        
              return super.onNextClick();
       }

       private getBirthPlace(): string {

            if ( !this.parent.placeOfBirth.country ) return "";
            if ( this.parent.placeOfBirth.country == Country.CANADA ) 
                 return this.items.provinceList.get(this.parent.placeOfBirth.province);
            else
            if ( this.parent.placeOfBirth.country != Code.NotFound ) 
                 return this.items.countryList.get(this.parent.placeOfBirth.country);
            else return this.parent.placeOfBirth.otherCountry;
       }

       resetOtherLastNameAtBirth(parent){
            parent.lastNameAtBirth = '';
       }

       resetOtherPreviousName(parent){
            parent.previousLastName = '';
       }
}

